<template>
  <v-container style="padding-top: 24px;">
    <v-row justify="center">
      <h1>Enter your {{ companyTitle }} Client Account Number here:</h1>
    </v-row>
    <v-row justify="center">
      <v-col
        sm="6"
        md="4"
      >
        <v-form @submit.prevent="searchTracking(trackingNumber)">
          <v-text-field
            id="order-search"
            v-model.trim.number="trackingNumber"
            label="Client Account Number"
            placeholder="123456789"
            outlined
            solo
            append-icon="fa-arrow-right"
            @click:append="searchTracking(trackingNumber)"
          />
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import router from "@/router";

export default {
  props: {
    companyTitle: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      trackingNumber: "",
    };
  },
  methods: {
    searchTracking: (trackingNumber: string) => {
      router.push(`/sofie/${trackingNumber}`);
    },
  },
};
</script>
